var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.45837 7.91666C1.45837 7.57148 1.7382 7.29166 2.08337 7.29166H17.9167C18.2619 7.29166 18.5417 7.57148 18.5417 7.91666V16.6667C18.5417 17.4721 17.8888 18.125 17.0834 18.125H2.91671C2.1113 18.125 1.45837 17.4721 1.45837 16.6667V7.91666ZM2.70837 8.54166V16.6667C2.70837 16.7817 2.80164 16.875 2.91671 16.875H17.0834C17.1984 16.875 17.2917 16.7817 17.2917 16.6667V8.54166H2.70837Z",
    fill: "#969696"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.91671 3.54166C2.80165 3.54166 2.70837 3.63493 2.70837 3.74999V7.29166H17.2917V3.74999C17.2917 3.63492 17.1984 3.54166 17.0834 3.54166H2.91671ZM1.45837 3.74999C1.45837 2.94457 2.11129 2.29166 2.91671 2.29166H17.0834C17.8888 2.29166 18.5417 2.94458 18.5417 3.74999V7.91666C18.5417 8.26183 18.2619 8.54166 17.9167 8.54166H2.08337C1.7382 8.54166 1.45837 8.26183 1.45837 7.91666V3.74999Z",
    fill: "#969696"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66663 1.04166C7.0118 1.04166 7.29163 1.32148 7.29163 1.66666V4.99999C7.29163 5.34517 7.0118 5.62499 6.66663 5.62499C6.32145 5.62499 6.04163 5.34517 6.04163 4.99999V1.66666C6.04163 1.32148 6.32145 1.04166 6.66663 1.04166Z",
    fill: "#969696"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3334 1.04166C13.6786 1.04166 13.9584 1.32148 13.9584 1.66666V4.99999C13.9584 5.34517 13.6786 5.62499 13.3334 5.62499C12.9882 5.62499 12.7084 5.34517 12.7084 4.99999V1.66666C12.7084 1.32148 12.9882 1.04166 13.3334 1.04166Z",
    fill: "#969696"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0416 14.1667C11.0416 13.8215 11.3214 13.5417 11.6666 13.5417H14.1666C14.5118 13.5417 14.7916 13.8215 14.7916 14.1667C14.7916 14.5118 14.5118 14.7917 14.1666 14.7917H11.6666C11.3214 14.7917 11.0416 14.5118 11.0416 14.1667Z",
    fill: "#969696"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20837 14.1667C5.20837 13.8215 5.4882 13.5417 5.83337 13.5417H8.33337C8.67855 13.5417 8.95837 13.8215 8.95837 14.1667C8.95837 14.5118 8.67855 14.7917 8.33337 14.7917H5.83337C5.4882 14.7917 5.20837 14.5118 5.20837 14.1667Z",
    fill: "#969696"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0416 10.8333C11.0416 10.4882 11.3214 10.2083 11.6666 10.2083H14.1666C14.5118 10.2083 14.7916 10.4882 14.7916 10.8333C14.7916 11.1785 14.5118 11.4583 14.1666 11.4583H11.6666C11.3214 11.4583 11.0416 11.1785 11.0416 10.8333Z",
    fill: "#969696"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20837 10.8333C5.20837 10.4882 5.4882 10.2083 5.83337 10.2083H8.33337C8.67855 10.2083 8.95837 10.4882 8.95837 10.8333C8.95837 11.1785 8.67855 11.4583 8.33337 11.4583H5.83337C5.4882 11.4583 5.20837 11.1785 5.20837 10.8333Z",
    fill: "#969696"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/Schedule.68a3851436b0a8a3dc4e24f30d724d80.svg";
export { ForwardRef as ReactComponent };